/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { ProductDetailsPriceBreaks, Promotion, TypesensePriceBreak } from "../storage";

export interface PromotionBadge {
  label: string;
}

export const BUY_MORE_AND_SAVE_LABEL = "Buy more and save";
export const TRADER_DEAL_LABEL = "Trader Deal";

export function getPromotionBadges(
  promotions: Promotion[] | undefined,
  priceBreaks: (TypesensePriceBreak | ProductDetailsPriceBreaks)[] | undefined,
  traderDealsValue: string,
  traderDealsEnabled: boolean,
  buyBreaksEnabled: boolean
): PromotionBadge[] {
  const isTraderDeal = traderDealsEnabled && promotions?.some((p) => p.type === traderDealsValue);

  const buyMoreSaveMore = buyBreaksEnabled && priceBreaks && priceBreaks.length > 0;

  return [
    ...(isTraderDeal ? [{ label: TRADER_DEAL_LABEL }] : []),
    ...(buyMoreSaveMore ? [{ label: BUY_MORE_AND_SAVE_LABEL }] : []),
  ];
}
